module.exports = __webpack_public_path__ + "img/full7-min.de330b87.png";